import { decode } from 'html-entities/lib';
import { Link } from '@99designs/emu';
import { FormattedReactMessage } from '@99designs/frontend-components/i18n';

interface FormattedFeatureProps {
    name: string;
    linksReplacements: Record<string, string>;
}

export function FormattedFeatureName({ name, linksReplacements }: FormattedFeatureProps) {
    const replacements: Record<string, React.ReactElement> = {};

    Object.entries(linksReplacements).forEach(([key, value]) => {
        replacements[key] = <Link href={value} openInNewTab />;
    });

    return <FormattedReactMessage message={decode(name)} replacements={replacements} />;
}
